import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRouteSign = ({ sign, redirectPath = '/sign' }: any) => {
  if (!sign.identityValidated) {
    return <Navigate to={redirectPath} replace />;
  }
    return <Outlet />;
};
  